/**
 * @desc pda版本-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PdaVersionResponseDto>
>;
export function request(
  params: API.basics.pdaVersion.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/pda/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
